<template>
  <div>
    <!-- BEGIN: Modal Toggle -->
    <div class="text-center">
      <a
        class="btn btn-primary"
        @click="openEditModal"
      >
        <PlusIcon class="h-3 w-3 mr-1" />
        เพิ่มผู้ใช้งาน
      </a>
    </div>
    <ModalLayout v-model="openModalStatus" :headerTitle="`${headTitle}ผู้ใช้งาน`" @click:save="saveForm" :isDone="isDone" @click:cancel="clearModal" :isViewOnly="viewState?true:false">
        <div class="grid grid-cols-12 gap-4 gap-y-3">
            <div class="col-span-12">
                <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                กลุ่มผู้ใช้งาน
                </h3>
            </div>
            <div class="col-span-12 lg:col-span-6 ">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-group" class="form-label text-theme-98 sm:w-[6rem]">กลุ่มผู้ใช้งาน <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <v-select
                            data-test="user-group"
                            id="user-group"
                            placeholder="กรุณาเลือกกลุ่มผู้ใช้งาน"
                            label="role_code"
                            :clearable="false"
                            :options="roleName.filter(item=>item.role_code != 'vt')"
                            v-model="validate.user_group.$model"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.user_group.$error}"
                            :disabled="viewState?true:false"
                        >
                            <template #option="{ role_code }">
                                <span class="uppercase">{{role_code == "cm" && !viewState ? 'cm & vt': role_code}}</span>
                            </template>
                            <template #selected-option="{ role_code }">
                                <span class="uppercase">{{role_code == "cm" && !viewState ? 'cm & vt': role_code}}</span>
                            </template>
                            <template #no-options="{}">
                            ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                        </v-select>
                        <template v-if="validate.user_group.$error">
                            <div
                                v-for="(error, index) in validate.user_group.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div> 
                    <!-- <div class="input-errors" v-for="error of v$.typeofFamilySelected.$errors" :key="error.$uid">
                    <div class="error-msg">{{ error.$message }}</div>
                    </div> -->
                </div>
            </div>
            <div class="col-span-12 py-5">
                <div class="w-full border-t dark:border-dark-5 border-theme-34"></div>
            </div>
            <div class="col-span-12">
                <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                ข้อมูลผู้ใช้งาน
                </h3>
            </div>
            <div class="col-span-12 lg:col-span-6 ">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-position" class="form-label text-theme-98 sm:w-[6rem]">ตำแหน่ง</label>
                    <input
                        id="user-position"
                        type="text"
                        class="form-control"
                        placeholder="กรุณากรอกตำแหน่ง"
                        data-test="user-position"
                        v-model="userForm.position"
                        disabled
                    >
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 ">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-short-position" class="form-label text-theme-98 sm:w-[6rem]">ตำแหน่งย่อ</label>
                    <input
                        id="user-short-position"
                        type="text"
                        class="form-control"
                        placeholder="กรุณากรอกตำแหน่งย่อ"
                        data-test="user-short-position"
                        v-model="userForm.short_position"
                        disabled
                    >
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 " v-if="currentSelectedRole == 'hcm' || currentSelectedRole == 'dv' || currentSelectedRole == 'et'">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-organize" class="form-label text-theme-98 sm:w-[6rem]">หน่วยงาน <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <v-select
                            data-test="user-organize"
                            id="user-organize"
                            placeholder="กรุณาเลือกหน่วยงาน"
                            :clearable="false"
                            :options="organizeOptions"
                            @option:selected="getSubOrganize"
                            v-model="validate.organize.$model"
                            label="AGC_NAME"
                            :reduce="label => label"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.organize.$error}"
                            :disabled="viewState?true:false"
                        >
                            <template #no-options="{}">
                            ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                        </v-select>
                        <template v-if="validate.organize.$error">
                                <div
                                    v-for="(error, index) in validate.organize.$errors"
                                    :key="index"
                                    class="text-theme-24 mt-1 text-xs"
                                >
                                    {{ error.$message }}
                                </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 " v-if="currentSelectedRole == 'hcm' || currentSelectedRole == 'dv'">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-sub-organize" class="form-label text-theme-98 sm:w-[6rem]" style="padding-left: 1px;">หน่วยงานย่อย <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <v-select
                            class="flex-1"
                            data-test="user-sub-organize"
                            id="user-sub-organize"
                            placeholder="กรุณาเลือกหน่วยงานย่อย"
                            label="ORG_NAME"
                            :clearable="false"
                            :options="subOrganizeOptions"
                            :reduce="label => label"
                            v-model="validate.sub_organize.$model"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.sub_organize.$error}"
                            :disabled="viewState?true:false"
                        >
                            <template #no-options="{}">
                            ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                        </v-select>
                        <template v-if="validate.sub_organize.$error">
                            <div
                                v-for="(error, index) in validate.sub_organize.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 " v-if="currentSelectedRole == 'cm' || currentSelectedRole == 'oh' || currentSelectedRole == 'hcm'">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-province" class="form-label text-theme-98 sm:w-[6rem]">จังหวัด <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <v-select
                            class="flex-1"
                            data-test="user-province"
                            id="user-province"
                            placeholder="กรุณาเลือกจังหวัด"
                            :clearable="false"
                            :options="provinceOptions"
                            v-model="validate.province.$model"
                            :reduce="label => label"
                            label="province_name"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.province.$error}"
                            :disabled="viewState?true:false"
                        >
                            <template #no-options="{}">
                            ไม่พบข้อมูล
                            </template>
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"><ChevronDownIcon class="w-5 h-5"/></span>
                            </template>
                        </v-select>
                        <template v-if="validate.province.$error">
                            <div
                                v-for="(error, index) in validate.province.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 " v-if="currentSelectedRole == 'tpso'">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-osm" class="form-label text-theme-98 sm:w-[6rem]">สสว. <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <input
                            id="user-osm"
                            type="text"
                            class="form-control"
                            placeholder="กรุณากรอกหมายเลข สสว."
                            data-test="user-osm"
                            v-model="validate.osm.$model"
                            :class="{ 'border-1 border-theme-24 rounded-[9px]': validate.osm.$error}"
                            :disabled="viewState?true:false"
                        >
                         <template v-if="validate.osm.$error">
                            <div
                                v-for="(error, index) in validate.osm.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 py-5" v-if="viewState">
                <div class="w-full border-t dark:border-dark-5 border-theme-34"></div>
            </div>
            <div class="col-span-12" v-if="viewState">
                <h3 class="font-medium text-base mr-auto font-bold text-theme-20">
                บัญชีผู้ใช้งาน
                </h3>
            </div>
            <div class="col-span-12 lg:col-span-6 " v-if="viewState">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-username" class="form-label text-theme-98 sm:w-[6rem]">ชื่อผู้ใช้งาน <span v-if="currentSelectedRole == 'cm' && !viewState">CM</span>
                        <!-- <span class="text-theme-5">*</span> -->
                    </label>
                    <div class="flex-1">
                        <input
                            id="user-username"
                            type="text"
                            class="form-control"
                            placeholder="กรุณากรอกชื่อผู้ใช้งาน"
                            data-test="user-username"
                            v-model="userForm.username"
                            disabled
                        >
                        <!-- <template v-if="validate.username.$error">
                            <div
                                v-for="(error, index) in validate.username.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                        <template v-if="isInvalidUsername">
                            <div
                                class="text-theme-24 mt-1 text-xs"
                            >
                                ชื่อผู้ใช้งานต้องเป็นภาษาอังกฤษ ตัวเลข หรือสัญลักษณ์ . และ _ เท่านั้น
                            </div>
                        </template> -->
                    </div>
                </div>
            </div>
            <!-- <div class="col-span-12 lg:col-span-6 " v-if="!viewState">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-pw" class="form-label text-theme-98 sm:w-[6rem]">รหัสผ่าน
                    </label>
                    <div class="flex-1">
                        <div class="flex">
                            <input
                                id="user-pw"
                                :type="showPassword ? 'text': 'password'"
                                class="form-control"
                                placeholder="กรุณากรอกรหัสผ่าน"
                                data-test="user-pw"
                                v-model="validate.password.$model"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.password.$error}"
                                disabled
                            >
                        </div>
                        <template v-if="validate.password.$error">
                            <div
                                v-for="(error, index) in validate.password.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 " v-if="currentSelectedRole == 'cm' && !viewState">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-username-vt" class="form-label text-theme-98 sm:w-[6rem]">ชื่อผู้ใช้งาน VT
                    </label>
                    <div class="flex-1">
                        <input
                            id="user-username-vt"
                            type="text"
                            class="form-control"
                            placeholder="กรุณากรอกชื่อผู้ใช้งาน"
                            data-test="user-username-vt"
                            v-model="usernameVTGenerator"
                            :class="{ 'border-1 border-theme-24 rounded-md': validate.username_vt.$error}"
                            disabled
                        >
                        <template v-if="validate.username_vt.$error">
                            <div
                                v-for="(error, index) in validate.username_vt.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>
            <div class="col-span-12 lg:col-span-6 " v-if="currentSelectedRole == 'cm' && !viewState">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-pw-vt" class="form-label text-theme-98 sm:w-[6rem]">รหัสผ่าน
                    </label>
                    <div class="flex-1">
                        <div class="flex">
                            <input
                                id="user-pw-vt"
                                :type="showPassword ? 'text': 'password'"
                                class="form-control"
                                placeholder="กรุณากรอกรหัสผ่าน"
                                data-test="user-pw-vt"
                                v-model="validate.password_vt.$model"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.password_vt.$error}"
                                disabled
                            >
                        </div>
                        <template v-if="validate.password_vt.$error">
                            <div
                                v-for="(error, index) in validate.password_vt.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                    </div>
                </div>
            </div>-->
            <!-- <div class="col-span-12 lg:col-span-6 ">
                <div class="form-inline items-baseline pl-[10px]">
                    <label for="user-cf-pw" class="form-label text-theme-98 sm:w-[6rem]">ยืนยันรหัสผ่าน <span class="text-theme-5">*</span></label>
                    <div class="flex-1">
                        <div class="flex">
                            <input
                                id="user-cf-pw"
                                :type="showConfirmPassword ? 'text' : 'password'"
                                class="form-control"
                                placeholder="กรุณากรอกยืนยันรหัสผ่าน"
                                data-test="user-cf-pw"
                                v-model="validate.confirm_password.$model"
                                :class="{ 'border-1 border-theme-24 rounded-md': validate.confirm_password.$error || isNotSameAsPassword}"
                                :state="isNotSameAsPassword"
                                @input="checkSameAsPassword"
                            >
                            <button class="btn btn-secondary ml-1" style="padding-top: 10px;padding-bottom: 10px;" @click="showConfirmPassword = !showConfirmPassword">
                                <EyeOffIcon class="w-4 h-4" v-if="!showConfirmPassword"/>
                                <EyeIcon class="w-4 h-4" v-else/>
                            </button>
                        </div>
                        <template v-if="validate.confirm_password.$error">
                            <div
                                v-for="(error, index) in validate.confirm_password.$errors"
                                :key="index"
                                class="text-theme-24 mt-1 text-xs"
                            >
                                {{ error.$message }}
                            </div>
                        </template>
                        <template v-if="isNotSameAsPassword">
                            <div
                                class="text-theme-24 mt-1 text-xs"
                            >
                                ยืนยันรหัสผ่านไม่ตรงกัน
                            </div>
                        </template>
                    </div>
                </div>
            </div> -->
        </div>
    </ModalLayout>
  </div>
</template>
<script setup>
import { ref, watch, toRefs, reactive, onMounted, computed } from 'vue'
import ModalLayout from "@/components/base/custom-modal/CustomModalLayout.vue"
import useVuelidate from '@vuelidate/core'
import { required, helpers, minLength, requiredUnless, requiredIf } from '@vuelidate/validators'
import Swal from "sweetalert2"
import { getProvince, getOrganize, getSubOrganizeByOrganize } from "@/utils/get-option-data"
import roleName from "@/data/roles_name.json"
import axios from 'axios'
import { useStore } from 'vuex'

const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})

const emit = defineEmits(["closeModal"])
const props = defineProps({
    viewState: {
        type: Object
    },
})
const store = useStore()
const cancelData = ref(false)
const openModalStatus = ref(false)
const userForm = reactive({
    user_group: null,
    position: null,
    short_position: null,
    organize: null,
    sub_organize: null,
    province: null,
    username: null,
    password: null,
    confirm_password: null,
    username_vt: null,
    password_vt: null,
    osm:null,

})
const organizeOptions = ref()
const subOrganizeOptions = ref()
const provinceOptions = ref()
const isDone = ref(false)
const headTitle = ref("เพิ่ม")
const showPassword = ref(true) //false
const showConfirmPassword = ref(false)
const isInvalidUsername = ref(null)
const isNotSameAsPassword = ref(null)

function cancelModalForm(){
    cancelData.value = true
    openModalStatus.value = false
}
function openEditModal(){
    openModalStatus.value = true
    cancelData.value = false
}
const rules = {
    user_group: {
        required: helpers.withMessage(`กรุณาเลือกกลุ่มผู้ใช้งาน`, required)
    },
    organize: {
        required: helpers.withMessage(`กรุณาเลือกหน่วยงาน`, requiredIf(()=>currentSelectedRole.value == 'hcm' || currentSelectedRole.value == 'dv' || currentSelectedRole.value == 'et'))
    },
    sub_organize: {
        required: helpers.withMessage(`กรุณาเลือกหน่วยงานย่อย`, requiredIf(()=>currentSelectedRole.value == 'hcm' || currentSelectedRole.value == 'dv'))
    },
    province: {
        required: helpers.withMessage(`กรุณาเลือกจังหวัด`, requiredIf(()=>currentSelectedRole.value == 'cm' || currentSelectedRole.value == 'oh' || currentSelectedRole.value == 'hcm'))
    },
    /*username:{
        required: helpers.withMessage(`กรุณากรอกชื่อผู้ใช้งาน (username)`, required)
    },
    username_vt:{
        required: helpers.withMessage(`กรุณากรอกชื่อผู้ใช้งาน (username)`, requiredIf(()=>currentSelectedRole.value == 'cm'))
    },
    password:{
        required: helpers.withMessage(`กรุณากรอกรหัสผ่าน`, requiredUnless(()=>props.viewState)),
        minLength: helpers.withMessage(`รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร`,minLength(6)),
    },
    password_vt:{
        required: helpers.withMessage(`กรุณากรอกรหัสผ่าน`, requiredIf(() => !props.viewState && (currentSelectedRole.value == 'cm'))),
        minLength: helpers.withMessage(`รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร`,minLength(6)),
    },*/
    // confirm_password:{
    //     required: helpers.withMessage(`กรุณากรอกยืนยันรหัสผ่าน`, requiredUnless(()=>props.editState)),
    //     minLength: helpers.withMessage(`รหัสผ่านต้องมีความยาวอย่างน้อย 6 ตัวอักษร`,minLength(6)),
    // },
    osm:{
        required: helpers.withMessage(`กรุณากรอกหมายเลข สสว.`, requiredIf(()=>currentSelectedRole.value == "tpso"))
    }
}
const validate = useVuelidate(rules, toRefs(userForm), { $scope: false })
const saveForm = () =>{
    validate.value.$touch()
    if(validate.value.$invalid || isInvalidUsername.value){
        return ;
    }
    try{
        swalCustom.fire({
            text:"ยืนยันบันทึกข้อมูล",
            icon:"info",
            showCancelButton: true,
            reverseButtons: true,
            confirmButtonText: 'ตกลง',
            cancelButtonText: 'ยกเลิก',
        }).then(async (result)=>{
            if (result.isConfirmed) {
                userForm.password = getRandomPassword()
                let payload = {
                    username: usernameGenerator.value,
                    credentials: [{temporary: false, type: "password", value: userForm.password}],
                    attributes: {
                        positionName: userForm.user_group.position_name,
                        positionNameShort: userForm.user_group.position_name_short,
                        roleCode: userForm.user_group.role_code,
                    }
                }
                let vt_payload = {
                    username: "vt",
                    enabled: true,
                    // credentials: [{temporary: false, type: "password", value: getRandomPassword()}],
                    attributes: {
                        positionName: roleName.find(({role_code}) => role_code == "vt").position_name,
                        positionNameShort: roleName.find(({role_code}) => role_code == "vt").position_name_short,
                        roleCode: "vt",
                    }
                }
                if(userForm.user_group.role_code == "cm"){
                    payload["enabled"] = true
                    payload["clientRoles"] = {
                        "mso-logbook": [
                            "subordinate_vt_entry_modify",
                            "subordinate_vt_entry_view"
                        ]
                    }
                    payload["attributes"] = {
                        ...payload.attributes,
                        provinceName: userForm.province.province_name,
                        provinceCode: userForm.province._id.province_ID,
                        osmCode: userForm.province.mso_osm,
                        subordinateVt: "vt"
                    }
                    //for vt role
                    userForm.password_vt = getRandomPassword()
                    vt_payload["credentials"] = [{temporary: false, type: "password", value: userForm.password_vt}]
                    vt_payload["clientRoles"] = {
                        "mso-logbook": [
                            "entry_create",
                            "entry_modify",
                            "entry_view"
                        ]
                    }
                    vt_payload["attributes"] = {
                        ...vt_payload.attributes,
                        provinceName: userForm.province.province_name,
                        provinceCode: userForm.province._id.province_ID,
                        osmCode: userForm.province.mso_osm,
                        supervisor: "cm"
                    }
                }
                if(userForm.user_group.role_code == "hcm"){
                    payload["clientRoles"] = {
                        "mso-logbook": [
                            "subordinate_cm_entry_view",
                            "entry_approve",
                            "report_view",
                            "dashboard_view"
                        ]
                    }
                    payload["attributes"] = {
                        ...payload.attributes,
                        provinceName: userForm.province.province_name,
                        provinceCode: userForm.province._id.province_ID,
                        osmCode: userForm.province.mso_osm,
                        orgName: userForm.sub_organize.ORG_NAME,
                        orgCode: userForm.sub_organize.ORG_CODE,
                        agcName: userForm.organize.AGC_NAME,
                        agcCode: userForm.organize.AGC_CODE
                    }
                }
                if(userForm.user_group.role_code == "oh"){
                    payload["clientRoles"] = {
                        "mso-logbook": [
                            "subordinate_cm_entry_view",
                            "report_view",
                            "dashboard_view"
                        ]
                    }
                    payload["attributes"] = {
                        ...payload.attributes,
                        provinceName: userForm.province.province_name,
                        provinceCode: userForm.province._id.province_ID,
                        osmCode: userForm.province.mso_osm
                    }
                }
                if(userForm.user_group.role_code == "tpso"){
                    payload["clientRoles"] = {
                        "mso-logbook": [
                            "report_view",
                            "dashboard_view"
                        ]
                    }
                    payload["attributes"] = {
                        ...payload.attributes,
                        osmCode: userForm.osm
                    }
                }
                if(userForm.user_group.role_code == "dv"){
                    payload["clientRoles"] = {
                        "mso-logbook": [
                            "report_view",
                            "dashboard_view"
                        ]
                    }
                    payload["attributes"] = {
                        ...payload.attributes,
                        orgName: userForm.sub_organize.ORG_NAME,
                        orgCode: userForm.sub_organize.ORG_CODE,
                        agcName: userForm.organize.AGC_NAME,
                        agcCode: userForm.organize.AGC_NAME
                    }
                }
                if(userForm.user_group.role_code == "et"){
                    payload["clientRoles"] = {
                        "mso-logbook": [
                            "report_view",
                            "dashboard_view"
                        ]
                    }
                    payload["attributes"] = {
                        ...payload.attributes,
                        agcName: userForm.organize.AGC_NAME,
                        agcCode: userForm.organize.AGC_NAME
                    }
                }
                const token = store.getters["userAuth/getToken"];
                const config = {
                    url: `${process.env.VUE_APP_BASE_API}kcadmin/users${userForm.user_group.role_code == "cm" ? "/cm" : ""}`,
                    method: `POST`,
                    headers:{
                        Authorization: `Bearer ${token}`,
                        "Content-Type": `application/json; charset=utf-8`,
                    },
                    data: userForm.user_group.role_code == "cm" ? {
                            cm: payload,
                            vt: vt_payload
                        }
                        : payload
                };
                const insertSuccess = await axios(config)
                .catch(()=>
                    swalCustom.fire({
                        text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
                        icon: "warning",
                        // timer: 3000, //timeOut for auto-close
                        confirmButtonText: "ปิด",
                    })
                )
                if(insertSuccess.status == 201){
                    swalCustom.fire({
                        html: `<strong>ชื่อผู้ใช้งานและรหัสผ่าน คือ</strong>\
                                ${userForm.user_group?.role_code == "cm" ?
                                "<div class='wrap_user'>\
                                    <table class='m-auto'>\
                                        <tbody>\
                                            <tr><td class='px-2 text-right'>ชื่อผู้ใช้งาน CM :</td><td class='px-2 text-left''> " +insertSuccess.data.cm.username +"</td></tr>\
                                            <tr><td class='px-2 text-right'>รหัสผ่าน :</td><td class='px-2 text-left''> "+userForm.password+"</td></tr>\
                                            <tr><td class='px-2 text-right'>ชื่อผู้ใช้งาน VT :</td><td class='px-2 text-left''> " +insertSuccess.data.vt.username +"</td></tr>\
                                            <tr><td class='px-2 text-right'>รหัสผ่าน :</td><td class='px-2 text-left''> "+userForm.password_vt+"</td></tr>\
                                        </tbody>\
                                    </table>\
                                    <div class='text-md mb-1 mt-5 flex items-center justify-center gap-1'><input type='checkbox' id='accept' name='accept' value='yes' /> <label for='accept'>รับทราบ</label></div>\
                                </div>" :
                                "<div class='wrap_user'>\
                                    <table class='m-auto'>\
                                        <tbody>\
                                            <tr><td class='px-2 text-right'>ชื่อผู้ใช้งาน :</td><td class='px-2 text-left''> " +insertSuccess.data.username +"</td></tr>\
                                            <tr><td class='px-2 text-right'>รหัสผ่าน :</td><td class='px-2 text-left'> "+userForm.password+"</td></tr>\
                                        </tbody>\
                                    </table>\
                                    <div class='text-md mb-1 mt-5 flex items-center justify-center gap-1'><input type='checkbox' id='accept' name='accept' value='yes' /> <label for='accept'>รับทราบ</label></div>\
                                </div>"
                                }`,
                        icon: "success",
                        confirmButtonText: "ปิด",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        showConfirmButton: true,
                        preConfirm: () =>{
                            let value = document.querySelector('#accept');
                            if(!value.checked)
                                swalCustom.showValidationMessage('กรุณายืนยัน');
                        }
                    }).then(() => {
                        clearModal()
                    });
                }
            }
        })
    }
    catch(err){
        console.log("Error! ",err);
        swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            // timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
        });
    }
}
function clearModal(isUpdate=null){
    userForm.user_group = null
    userForm.position = null
    userForm.short_position = null
    userForm.organize = null
    userForm.sub_organize = null
    userForm.province = null
    userForm.username = null
    userForm.password = null
    userForm.confirm_password = null
    userForm.username_vt = null
    userForm.password_vt = null
    userForm.osm = null
    isInvalidUsername.value = null
    isNotSameAsPassword.value = null
    // showPassword.value = false
    showConfirmPassword.value = false
    isDone.value = false
    validate.value.$reset()
    openModalStatus.value = false
    headTitle.value = "เพิ่ม"
    emit("closeModal",isUpdate)
}
async function getOrganizeOptions(){
    organizeOptions.value = await getOrganize();
}
async function getSubOrganize(val){
    userForm.sub_organize = null
    subOrganizeOptions.value = await getSubOrganizeByOrganize(val)
}
//clear modal when close view data
watch(()=>openModalStatus.value,(val)=>{
    if(!val && props.viewState){
        clearModal()
    }
})
watch(()=>props.viewState,(val)=>{
    if(val){
        openModalStatus.value = true
        headTitle.value = "แสดงข้อมูล"
        userForm.username = val.username
        userForm.user_group = val.attributes?.roleCode?.[0]
        userForm.position = val.attributes?.positionName?.[0]
        userForm.short_position =  val.attributes?.positionNameShort?.[0]
        userForm.organize = val.attributes?.agcName?.[0]
        userForm.sub_organize = val.attributes?.orgName?.[0]
        userForm.province = val.attributes?.provinceName?.[0]
        userForm.osm = val.attributes?.osmCode?.[0]
    }
})
watch(()=>userForm.user_group, (val)=>{
    if(val && !props.viewState){
        userForm.position = val.position_name
        userForm.short_position = val.position_name_short
        userForm.username = null
        userForm.username_vt = null
        userForm.password = null
        userForm.password_vt = null
        userForm.organize = null
        userForm.sub_organize = null
        userForm.province = null
        userForm.osm = null
        validate.value.$reset()
    }
})
onMounted(async ()=>{
    await getOrganizeOptions()
    provinceOptions.value = await getProvince()
})

const currentSelectedRole = computed(()=>{
    if(userForm.user_group && !props.viewState){
        return userForm.user_group.role_code
    }
    else if(props.viewState){
        return userForm.user_group == "vt" ? "cm" : userForm.user_group
    }
    return null
})

const getRandomPassword = () =>{
    return Math.floor(100000 + Math.random() * 900000).toString()
}


const usernameGenerator = computed(()=>{
    if((userForm.user_group?.role_code == "cm" || userForm.user_group?.role_code == "hcm") && userForm.province){
        return `${userForm.user_group.role_code == "cm" ? "cm" : "hcm"}`
    }
    else if(userForm.user_group?.role_code == "oh" && userForm.province){
        return `${userForm.user_group.role_code}${userForm.province._id.province_ID}`
    }
    else if(userForm.user_group?.role_code == "tpso" && userForm.osm){
        return `${userForm.user_group.role_code}${userForm.osm}`
    }
    else if(userForm.user_group?.role_code == "dv" && userForm.sub_organize){
        return `${userForm.user_group.role_code}0${userForm.sub_organize.ORG_CODE}`
    }
    else if(userForm.user_group?.role_code == "et" && userForm.organize){
        return `${userForm.user_group.role_code}0${userForm.organize.AGC_CODE}`
    }
    return null

})


</script>
<style lang="scss">

</style>

